<template>
  <div class="body_bm_step">
    <index-header></index-header>
    <div class="_wrapper">
      <div class="bm_step_box">
        <index-steps :step="1"></index-steps>
        <div class="bm_notes">
          <h2>{{sysName}}须知</h2>
          <div class="notes_box" v-if="signupData">
            <div class="_content">
              <textarea disabled>{{signupData.content}}</textarea>
            </div>
            <div class="_btn">
              <a v-if="isReadNotes" class="sx-btn sx-btn-gray" href="javascript:void(0)">请认真阅读 {{sendCodeSecond+1}}</a>
              <a v-else class="sx-btn sx-btn-blue" href="javascript:void(0)" @click="onClickGoLogin">已阅，下一步</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import IndexCommon from './mixins/index_common';
  import PageBmNotes from './mixins/page_bm_notes';

  import IndexHeader from './components/IndexHeader';
  import IndexSteps from './components/IndexSteps';

  export default {
    mixins: [IndexCommon, PageBmNotes],
    components: { IndexHeader, IndexSteps },
    data() {
      return {
      };
    },
    created() {
    },
    methods: {
    }
  };
</script>

<style lang="stylus" scoped>
  .bm_notes {
    padding 10px 40px 30px
    h2 {
      padding 40px 0 20px
      text-align center
      color #175375
      font-size 28px
      border-bottom 1px solid #e7e7e7
      margin-bottom 40px
    }

    .notes_box {
      margin 30px 80px
      padding 30px
      background #fbfbfb
      border-radius 12px
      ._content {
        padding 15px
        overflow-x hidden
        overflow-y auto
        textarea {
          text-indent 2em
          font-weight 100
          width 100%
          height 400px
          padding 0
          font-size 16px
          color #000
          line-height 2.2em
          background none
          border 0
        }
      }
      ._btn {
        padding 40px 0 20px
        text-align center
      }
    }
  }
</style>
